import {ROLE_STUDENT, ROLE_TEACHER} from "../constants";

export const isEducator = (user = null) => {
    return user && (user.persona === ROLE_TEACHER);
}

export const isLearner = (user = null) => {
    return user && user.persona === ROLE_STUDENT;
}
